import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Auth } from '../services/auth';
import { map } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  return auth.isAuthenticated$().pipe(
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        return router.parseUrl('/login');
      }
      return true;
    })
  );
};
